import { fetchRequest } from "@providers/conect";

const createOficinaEspecialidadSedeApi = async (data) => {
  try {
    const url = `especialidades-sedes/create`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const updateOficinaEspecialidadSedeApi = async (id, data) => {
  try {
    const url = `especialidades-sedes/update/${id}`;
    const response = await fetchRequest(url, {
      method: "PUT",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const viewOficinasEspecialidadesSedesApi = async (data) => {
  try {
    const url = `especialidades-sedes/view`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllOficinasEspecialidadesSedesApi = async () => {
  try {
    const url = `especialidades-sedes/all`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteOficinaEspecialidadSedeApi = async (id) => {
  try {
    const url = `especialidades-sedes/delete/${id}`;
    const response = await fetchRequest(url, {
      method: "DELETE"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getByEspecialidadApi = async (idEsp) => {
  try {
    const url = `especialidades-sedes/especialidad/${idEsp}`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getBySedeApi = async (idSed) => {
  try {
    const url = `especialidades-sedes/sede/${idSed}`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const bulkCreateOficinaEspecialidadSedeApi = async (data) => {
  try {
    const url = `especialidades-sedes/bulk-create`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export {
  createOficinaEspecialidadSedeApi,
  updateOficinaEspecialidadSedeApi,
  viewOficinasEspecialidadesSedesApi,
  getAllOficinasEspecialidadesSedesApi,
  deleteOficinaEspecialidadSedeApi,
  getByEspecialidadApi,
  getBySedeApi,
  bulkCreateOficinaEspecialidadSedeApi
};